/**
 * Canopy Theme - Variant Optimizer
 * 1. Hides impossible combinations (!important).
 * 2. Labels existing but out-of-stock items as "(Out of Stock)".
 */
(function() {
  const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
  if (!handle) return;

  let productData = null;

  async function getProduct() {
    if (productData) return productData;
    const res = await fetch(`/products/${handle}.js`);
    productData = await res.json();
    return productData;
  }

  const updateVariantUI = async () => {
    const product = await getProduct();
    const optionSections = document.querySelectorAll('.option-selector, .variant-wrapper');

    // CASE: Single Variant Products
    if (product.variants.length <= 1) {
      optionSections.forEach(s => s.style.setProperty('display', 'none', 'important'));
      return;
    }

    let selectedSoFar = [];

    optionSections.forEach((section, index) => {
      const active = section.querySelector('[aria-selected="true"], input:checked, select');
      const val = active ? (active.getAttribute('data-value') || active.value) : null;
      if (val) selectedSoFar.push(val);

      // Skip filtering first level, or filter subsequent levels
      const path = selectedSoFar.slice(0, index);
      const items = section.querySelectorAll('.js-option, option');

      items.forEach(item => {
        const itemVal = item.getAttribute('data-value') || item.value;
        
        // Find if any variant matches the path + this specific item
        const matchingVariants = product.variants.filter(v => {
          const matchesPath = path.every((p, i) => v.options[i] === p);
          return matchesPath && v.options[index] === itemVal;
        });

        const exists = matchingVariants.length > 0;
        const isAnyAvailable = matchingVariants.some(v => v.available);
        const labelEl = item.querySelector('span') || item;

        if (!exists) {
          // Impossible combination: Hide it
          item.style.setProperty('display', 'none', 'important');
        } else {
          // Combination exists: Show it
          item.style.setProperty('display', 'flex', 'important');
          
          // If it exists but is sold out, append "(Out of Stock)"
          if (!isAnyAvailable) {
            if (!labelEl.innerHTML.includes('(Out of Stock)')) {
              labelEl.innerHTML = `${itemVal} <small style="opacity: 0.6; margin-left: 5px;">(Out of Stock)</small>`;
            }
            item.classList.add('is-out-of-stock');
          } else {
            // If it's back in stock, ensure label is clean
            labelEl.innerHTML = itemVal;
            item.classList.remove('is-out-of-stock');
          }
        }
      });
    });
  };

  // Observe for theme changes
  const observer = new MutationObserver(() => updateVariantUI());
  const productForm = document.querySelector('form[action*="/cart/add"]');
  
  if (productForm) {
    observer.observe(productForm, { childList: true, subtree: true, attributes: true });
  }

  // Initial and backup runs
  updateVariantUI();
  setTimeout(updateVariantUI, 500);
  setTimeout(updateVariantUI, 1500);
})();